import { FC, useEffect, useRef } from 'react'
import { BasicStyledComponent, DSPageSections } from 'shared-definitions/types'
import styles from './TocTopSlider.module.css'
import clsx from 'clsx'
import PostNavLink from '../service/PostNavLink'
import { useTocMonitoring } from '../hooks/use-toc-monitoring'
import definedBreakpoints from 'shared-definitions/breakpoints.json'

interface TocTopSliderProps extends BasicStyledComponent {
  tableOfContentsItems: DSPageSections['items']
  activateTocScroll: boolean
}

// very similar to AltTableOfContentsList but designed for use
// as a separate component without responsive design
const TocTopSlider: FC<TocTopSliderProps> = ({
  tableOfContentsItems,
  className,
  activateTocScroll,
}) => {
  const ref = useRef<HTMLUListElement>(null)
  const { current } = useTocMonitoring(tableOfContentsItems)

  useEffect(() => {
    if (!current || !ref.current || !activateTocScroll) {
      return
    }

    if (window.innerWidth >= definedBreakpoints.lg) {
      return
    }

    const button = ref.current.querySelector(`[href="#${current.anchor}"]`)
    button?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  }, [current, activateTocScroll])

  return (
    <ul className={clsx(styles.navList, className)} ref={ref}>
      {tableOfContentsItems.map((item, index) => (
        <li
          key={index}
          className={clsx(styles.navItem, {
            [styles.navItemActive]: item.anchor === current?.anchor,
          })}
        >
          <PostNavLink section={item} key={index} className={styles.navButton} />
        </li>
      ))}
    </ul>
  )
}

export default TocTopSlider
